import React from 'react';
import WirelineEngagementsList from 'pages/WirelineEngagements/WirelineEngagementsMainPage/WirelineEngagementsList';

const WirelineEngagementsMainPage = () => (
  <WirelineEngagementsList />
);

export default WirelineEngagementsMainPage;
